import React from "react";

const Header = () => {
  return <a href="/">chord.name</a>;
};

export default Header;
